import React from 'react'
import Layout from '../components/UnifyLayout'
import TechPromo from '../components/TechPromo'
import TextVideoCTA from '../components/TextVideoCTA'
import NewsletterSignup from '../components/NewsletterSignup'
import ThreeCardGrid from '../components/ThreeCardGrid'
import ThreeTableGrid from '../components/ThreeTableGrid'
import Counters from '../components/Counters'
import IconBlocks from '../components/IconBlocks'
import LatestNews from '../components/LatestNews'
import SEO from '../components/SEO'
import Container from '../components/Container'
import PageTitle from '../components/PageTitle'
import ContactForm from '../components/ContactForm'

const Unify = ({ data }) => {
  return (
    <Layout>
      <TechPromo />
      <ThreeTableGrid />
      {/*
      <IconBlocks />
      <hr className="g-brd-gray-light-v4 my-0" />
      
      <hr className="g-brd-gray-light-v4 my-0" />
      <ThreeCardGrid />
      <TextVideoCTA />
      <Counters />
      <LatestNews />
      */}
      <NewsletterSignup />
    </Layout>
  )
}

export default Unify
